import Highcharts from 'highcharts';
import qs from 'qs';
import { MISSING_VALUE } from '../constants/stats';

const DATE_FORMAT = '%d-%b-%y';
const REPORT_DATE_FORMAT = '%d-%b-%Y';
export const BY_THREE = '0,0,000';
const NO_DECIMAL = '0';
export const ONE_DECIMAL = '0.0a';
export const TWO_DECIMAL = '0,0.00';
const INTEGER2_FORMAT = 'integer2';

export const dateFormat = (val: Date | number) => {
  const valAsNumber = typeof val === 'number' ? val : val.getTime();
  return Highcharts.dateFormat(DATE_FORMAT, valAsNumber);
};

export const reportDate = (val: Date | number) => {
  const valAsNumber = typeof val === 'number' ? val : val.getTime();
  return Highcharts.dateFormat(REPORT_DATE_FORMAT, valAsNumber);
};

/** @deprecated */
export const formatValue = (
  value: number | string | boolean | null | undefined,
  format: string | undefined = undefined,
  opts: { emptyValue?: string; suffix?: string } = {}
) => {
  const emptyValue = opts.emptyValue ?? MISSING_VALUE;
  const suffix = opts.suffix ?? '';

  if (!_.isNumber(value)) {
    return emptyValue;
  }

  // This switch approximates the functionality of numeral.js so the callers don't need to be updated.
  // Since this function is deprecated, a new formatter should be written and this one should be gradually removed.
  switch (format) {
    case BY_THREE: {
      return (
        new Intl.NumberFormat('en-US', {
          maximumFractionDigits: 0,
        }).format(value) + suffix
      );
    }
    case '0,0,000': {
      return new Intl.NumberFormat('en-US').format(value) + suffix;
    }
    case ONE_DECIMAL: {
      return (
        new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
          notation: 'compact',
        }).format(value) + suffix
      );
    }
    case NO_DECIMAL: {
      return (
        new Intl.NumberFormat('en-US', {
          maximumFractionDigits: 0,
          useGrouping: false,
        }).format(value) + suffix
      );
    }
    case TWO_DECIMAL: {
      return (
        new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(value) + suffix
      );
    }
    case INTEGER2_FORMAT: {
      return (
        new Intl.NumberFormat('en-US', {
          minimumIntegerDigits: 2,
          maximumFractionDigits: 0,
        }).format(value) + suffix
      );
    }
    case '0.00': {
      return (
        new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(value) + suffix
      );
    }
    default: {
      return format?.includes('$')
        ? new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            notation: format.includes('a') ? 'compact' : 'standard',
            minimumFractionDigits: format.includes('.00') ? 2 : 1,
            maximumFractionDigits: format.includes('.00') ? 2 : 1,
          }).format(value) + suffix
        : new Intl.NumberFormat('en-US').format(value) + suffix;
    }
  }
};

export const formatIncrementalVisits = (value: number | null, opts = {}) => {
  if (value && value < 0) {
    value = 0;
  }
  return formatValue(value, BY_THREE, opts);
};

export const urlWithParams = (url: string, params: Record<string, unknown>) =>
  `${url}?${qs.stringify(params)}`;

export const qsDefaults = {
  arrayFormat: 'brackets',
  encode: false,
} as const;
